import dayjs from 'dayjs'

export type RenewalStatusInput = {
    status?: string
    expiresOn?: string | Date | number | null
    isSub?: boolean
}

export type RenewalStatus = {
    expired: boolean
    expiring: boolean
    approved: boolean
    daysLeft: number
    monthsLeft: number
}

// Single source of truth for renewal-window calculations (3-month window, day precision)
export const getRenewalStatus = ({ status, expiresOn, isSub = false }: RenewalStatusInput): RenewalStatus => {
    const now = dayjs()
    const exp = expiresOn ? dayjs(expiresOn) : null

    // 'DucExpired' is the status the backend actually emits (DucStatus enum); there is no 'Expired'
    const expired = status === 'DucExpired' || (!!exp && exp.isBefore(now, 'day')) || false

    // Within 3 months, not expired, and most flows exclude subs from renewal prompts
    const expiring = status === 'Approved'
        && !expired
        && !isSub
        && !!exp
        && exp.isBefore(now.add(3, 'month'), 'day')

    const approved = status === 'Approved' && !expired && !expiring

    const daysLeft = exp ? Math.max(0, exp.diff(now, 'day')) : 0
    // Use month diff with decimals and round up to avoid 0 when a few days remain in the month
    const monthsLeftFloat = exp ? exp.diff(now, 'month', true) : 0
    const monthsLeft = exp ? Math.max(0, Math.ceil(monthsLeftFloat)) : 0

    return { expired, expiring, approved, daysLeft, monthsLeft }
}

export default getRenewalStatus
